/* React */
import React from "react";

/* React Katex */
import { BlockMath, InlineMath } from "react-katex";

/* Stylesheet */
import "katex/dist/katex.min.css";

export const kaplanMeierFormula = () => {
  return (
    <div className="p-4">
      <BlockMath
        math={`\\hat{S}(t) = \\prod_{t_i \\leq t} \\left(1 - \\frac{d_i}{n_i} \\right)`}
      />
      <div className="mt-4 text-sm text-gray-800 space-y-1">
        <div>
          <InlineMath math="t_i" />: time of event
        </div>
        <div>
          <InlineMath math="d_i" />: events at{" "}
          <InlineMath math="t_i" />
        </div>
        <div>
          <InlineMath math="n_i" />: at risk at{" "}
          <InlineMath math="t_i" />
        </div>
      </div>
    </div>
  );
};
